import styled from 'styled-components';

import { NewStyleColor } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';

interface ButtonProps {
	iconWidth: string;
	iconHeight: string;
	isActive?: boolean;
	isInverted?: boolean;
	disabled?: boolean;
}

const Button = styled('div').attrs({
	type: 'button',
})`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 38px;
	height: 38px;
	padding: 0;
	border: 0;
	border-radius: 6px;
	outline: 0;
	background-color: ${({ isActive, isInverted }: ButtonProps) => {
		if (isActive) {
			return NewStyleColor.Blue450;
		}
		if (isInverted) {
			return hexToRgba(NewStyleColor.White, 20);
		}
		return hexToRgba(NewStyleColor.White, 10);
	}};
	color: ${NewStyleColor.White};
	cursor: pointer;

	${({ disabled }: ButtonProps) => disabled && `
		cursor: default;
		opacity: 0.5;
	`}

	& + & {
		margin-top: 6px;
	}

	svg {
		width: ${({ iconWidth }: ButtonProps) => iconWidth};
		height: ${({ iconHeight }: ButtonProps) => iconHeight};
		fill: currentColor;
	}
`;

export {
	Button,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ActionsPanel/ActionButton/styles.ts